import { render, staticRenderFns } from "./ZGConclusion.vue?vue&type=template&id=45b132c3&scoped=true&"
import script from "./ZGConclusion.vue?vue&type=script&lang=js&"
export * from "./ZGConclusion.vue?vue&type=script&lang=js&"
import style0 from "./ZGConclusion.vue?vue&type=style&index=0&id=45b132c3&lang=scss&scoped=true&"
import style1 from "./ZGConclusion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b132c3",
  null
  
)

export default component.exports